// Add this component inside App.js or as a separate file
// Place it in the topbar or dashboard

export default function WarehouseSelector({ locations, locationId, onSelect }) {
  if (!locations || locations.length <= 1) return null;

  return (
    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
      <span style={{ fontSize:11, color:"#6b7280", whiteSpace:"nowrap" }}>📍 Warehouse:</span>
      <select
        value={locationId || ""}
        onChange={(e) => {
          const id = parseInt(e.target.value);
          localStorage.setItem("sellsync_location_id", id);
          onSelect(id);
        }}
        style={{ padding:"4px 8px", borderRadius:6, border:"1px solid #d1d5db", fontSize:12, fontFamily:"inherit", outline:"none", maxWidth:160 }}
      >
        {locations.map((loc) => (
          <option key={loc.id} value={loc.id}>{loc.name}</option>
        ))}
      </select>
    </div>
  );
}
